var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrcodeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3.5C3 3.22386 3.22386 3 3.5 3H4.5C4.77614 3 5 3.22386 5 3.5V4.5C5 4.77614 4.77614 5 4.5 5H3.5C3.22386 5 3 4.77614 3 4.5V3.5Z",
    fill: "#7D7D7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0C0.895431 0 0 0.895431 0 2V6C0 7.10457 0.895431 8 2 8H6C7.10457 8 8 7.10457 8 6V2C8 0.895431 7.10457 0 6 0H2ZM6 1.5H2C1.72386 1.5 1.5 1.72386 1.5 2V6C1.5 6.27614 1.72386 6.5 2 6.5H6C6.27614 6.5 6.5 6.27614 6.5 6V2C6.5 1.72386 6.27614 1.5 6 1.5Z",
    fill: "#7D7D7D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 13.5C3 13.2239 3.22386 13 3.5 13H4.5C4.77614 13 5 13.2239 5 13.5V14.5C5 14.7761 4.77614 15 4.5 15H3.5C3.22386 15 3 14.7761 3 14.5V13.5Z",
    fill: "#7D7D7D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 10.8954 0.895431 10 2 10H6C7.10457 10 8 10.8954 8 12V16C8 17.1046 7.10457 18 6 18H2C0.895431 18 0 17.1046 0 16V12ZM2 11.5H6C6.27614 11.5 6.5 11.7239 6.5 12V16C6.5 16.2761 6.27614 16.5 6 16.5H2C1.72386 16.5 1.5 16.2761 1.5 16V12C1.5 11.7239 1.72386 11.5 2 11.5Z",
    fill: "#7D7D7D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3C13.2239 3 13 3.22386 13 3.5V4.5C13 4.77614 13.2239 5 13.5 5H14.5C14.7761 5 15 4.77614 15 4.5V3.5C15 3.22386 14.7761 3 14.5 3H13.5Z",
    fill: "#7D7D7D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C10.8954 0 10 0.895431 10 2V6C10 7.10457 10.8954 8 12 8H16C17.1046 8 18 7.10457 18 6V2C18 0.895431 17.1046 0 16 0H12ZM16 1.5H12C11.7239 1.5 11.5 1.72386 11.5 2V6C11.5 6.27614 11.7239 6.5 12 6.5H16C16.2761 6.5 16.5 6.27614 16.5 6V2C16.5 1.72386 16.2761 1.5 16 1.5Z",
    fill: "#7D7D7D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 11V14H17C17.5523 14 18 14.4477 18 15V16.5C18 17.3284 17.3284 18 16.5 18H14.5C13.9477 18 13.5 17.5523 13.5 17V15.5H11C10.4477 15.5 10 15.0523 10 14.5V11.5C10 10.6716 10.6716 10 11.5 10H14C14.5523 10 15 10.4477 15 11ZM11.5 14H13.5V11.5L11.5 11.5L11.5 14ZM16.5 16.5H15V15.5H16.5V16.5Z",
    fill: "#7D7D7D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcodeIcon);
export default __webpack_public_path__ + "static/media/qrcode-icon.9f1aac540f30727fb6856a646b11385f.svg";
export { ForwardRef as ReactComponent };